import * as React from "react";
import {useContext} from "react";
import {ScreenContext} from "../screenContext";

export const useScreen = () => {
    const {state, dispatch} = useContext(ScreenContext);

    const changeScreen = (screenNumber, theEvent) => {
        dispatch({type: "changeScreen",payload:{screenNumber, theEvent}});
    }

    return {
        changeScreen,
        theEvent: state ? state.theEvent : [],
        screenNumber: state ? state.screenNumber : 1
    }
}
